<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <MonitorServiceProcessTableButton @notice='notice'></MonitorServiceProcessTableButton>
        <MonitorServiceProcessTable ref="monitorServiceProcess"></MonitorServiceProcessTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/BasicLayout';
import MonitorServiceProcessTableButton from "@/views/monitor/monitorServiceProcess/MonitorServiceProcessTableButton";
import MonitorServiceProcessTable from "@/views/monitor/monitorServiceProcess/MonitorServiceProcessTable";

export default {
  name: "monitorServiceProcessPage",
  components:{
    BasicLayout,
    MonitorServiceProcessTableButton,
    MonitorServiceProcessTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Monitor.monitor')}` + '/' + `${this.$t('Monitor.task.monitoringServiceProcess')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.monitorServiceProcess.getMonitorServiceProcessListData();
          break;
        case 'doActiveTask':
          this.$refs.monitorServiceProcess.doActiveTask();
          break;
        case 'doUnactiveTask':
          this.$refs.monitorServiceProcess.doUnactiveTask();
          break;
        default:
      }
    }
  }
}
</script>

<style scoped>

</style>
